import React from 'react';
import { Box, Typography, Chip } from '@mui/material';

const PageHeader = ({ title, count, action }) => (
    <Box
        sx={{
            display: 'flex',
            alignItems: { xs: 'flex-start', sm: 'center' },
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: 2,
            mb: 3,
        }}
    >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Typography
                variant="h5"
                fontWeight={700}
                sx={{ color: '#1a2332', letterSpacing: -0.3 }}
            >
                {title}
            </Typography>
            {count != null && (
                <Chip
                    label={count}
                    size="small"
                    sx={{
                        backgroundColor: '#e8f0f5',
                        color: '#427898',
                        fontWeight: 700,
                        fontSize: 12,
                        height: 22,
                        borderRadius: '6px',
                    }}
                />
            )}
        </Box>
        {action && <Box>{action}</Box>}
    </Box>
);

export default PageHeader;
